// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"195b869a","587":"a80739fa","634":"a939ade2"}[chunkId] + ".chunk.js";
};